import styled from "styled-components";
import { LinkStyleProps } from "../../interfaces/HeaderInterface";
import { NavLink } from "react-router-dom";

export const HeaderBlock = styled.header`
  position: fixed;
  width: 100%;
  background-color: #001b48;
  z-index: 10;
  overflow: visible;
`;

export const HeaderContainer = styled.div`
  color: #fff;
  overflow: visible;
`;

export const HeaderContent = styled.div`
  padding-top: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;

  .titles__block {
    display: flex;
    align-items: center;
    gap: 3.125rem;

    .buttons_block {
      display: flex;
      align-items: center;
      gap: 1.5rem;

      .header__buttons {
        width: 6.875rem;
        color: white;
        background: transparent;
        border: 1px solid white;
        font-size: 0.875rem;
        line-height: 1.063rem;
        padding: 0.563rem 1.875rem 0.563rem 1.875rem;
        font-weight: 500;
        text-align: center;
        transition: all 0.3s ease-in-out;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
        cursor: pointer;
      }

      .header__buttons:hover {
        color: black;
        background: white;
      }

      @media (max-width: 1024px) {
        display: none;
      }
    }
  }
  @media (max-width: 768px) {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
`;

export const LogoDesktop = styled.div`
  z-index: 20;
  width: 6.313rem;

  @media (max-width: 1200px) {
    width: 11.313rem;
  }

  @media (max-width: 1500px) {
    width: 13.313rem;
  }
`;

export const LogoMobile = styled.div`
  z-index: 20;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .logo__mobile__wrapper {
    z-index: 20;
    width: 6.875rem;
  }

  .logo__mobile__img {
    width: 100%;
  }
`;

export const HeaderNav = styled.nav`
  position: relative;

  .nav__ul {
    display: flex;
    align-items: center;
    gap: 3.75rem;
    position: relative;

    .main__list {
      position: relative;
      font-size: 0.875rem;
      line-height: 1.063rem;
      color: #fff;
      text-transform: uppercase;

      @media (max-width: 1024px) {
        display: none;
      }

      @media (max-width: 1180px) {
        font-size: 1rem;
      }

      &:hover .popup__menus__anim {
        visibility: visible;
        opacity: 100;
        transform: translateY(0.5rem);
      }

      .main__title {
        font-weight: 500;

        &:hover {
          transform: scale(1.1);
        }
      }

      .second__title {
        font-weight: 600;
        padding: 0.5rem 0.625rem 0.5rem 0.625rem;
        transform: scale(1) !important;

        &:hover {
          font-size: 1rem;
        }
      }
    }

    @media (max-width: 1240px) {
      gap: 3rem;
    }

    @media (max-width: 1180px) {
      font-size: 1rem;
    }
  }
`;

export const LinkStyle = styled(NavLink).withConfig({
  shouldForwardProp: (prop) => prop !== "actualRoute" && prop !== "titleRoute",
})<LinkStyleProps>`
  display: block;
  padding: 5px;
  transition: ease-in-out;
  transition-duration: 200ms;
  color: ${(props) =>
    props.titleRoute === props.actualRoute ? "#8282cd" : "white"};
  transform: ${(props) =>
    props.titleRoute === props.actualRoute ? "scale(1.1)" : "scale(1)"};

  &:hover {
    color: #8282cd;
  }
`;

export const PopUpMenus = styled.ul`
  z-index: 50;
  visibility: hidden;
  background-color: #0c0c6c;
  color: #757575;
  padding-right: 2rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  min-width: 18.75rem;
  position: absolute;
  top: 1.3rem;
  opacity: 0;
  transition: transform 200ms ease-in;
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

  p {
    font-size: 1.25rem;
    line-height: 1.75rem;
    color: white;
    padding: 0.625rem 0.75rem 0.625rem 0.75rem;
  }
`;

export const LangMenu = styled.select`
  background-color: #001b48;
  color: #fff;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.063rem;
  padding: 0.533rem 1.2rem 0.533rem 0.2rem;
  border: 1px solid white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;
